import React, { useReducer } from 'react'

const initState = () => ({
  noUtbk: '',
  group: '',
  scores: [],
  programStudies: [null, null],
  selectedCampus1: '',
  selectedCampus2: '',
  isTermsConditionsAccepted: false,
})

const reducer = (state, action) => {
  const copiedProgramStudies = [...state.programStudies]
  switch (action.type) {
    case 'SET_UTBK_NO':
      return ({
        ...state,
        noUtbk: action.payload,
      })
    case 'SET_GROUP':
      return ({
        ...state,
        group: action.payload,
      })
    case 'SET_SCORES':
      return ({
        ...state,
        scores: action.payload,
      })
    case 'ADD_SELECTED_PROGRAM_STUDY':
      copiedProgramStudies[action.payload.idx] = action.payload.programStudy
      return ({
        ...state,
        programStudies: copiedProgramStudies,
      })
    case 'SET_SELECTED_CAMPUS1':
      copiedProgramStudies[0] = null

      return ({
        ...state,
        selectedCampus1: action.payload,
        programStudies: copiedProgramStudies,
      })
    case 'SET_SELECTED_CAMPUS2':
      copiedProgramStudies[1] = null

      return ({
        ...state,
        selectedCampus2: action.payload,
        programStudies: copiedProgramStudies,
      })
    case 'SET_TERMS_CONDITION_ACCEPTANCE':
      return ({
        ...state,
        isTermsConditionsAccepted: action.payload,
      })
    case 'RESET_SCHOOLS_PROGRAM_STUDIES':
      return ({
        ...state,
        programStudies: [null, null],
        selectedCampus1: '',
        selectedCampus2: '',
      })
    case 'INIT_STATE_FROM_LOCALSTORAGE':
      return action.payload
    default:
      return state
  }
}

const PaperplaneFormContext = React.createContext(initState())

const PaperplaneFormProvider = ({ onSubmit, children }) => {
  const [state, dispatch] = useReducer(reducer, initState())
  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }
  return (
    <PaperplaneFormContext.Provider value={{ state, dispatch }}>
      <form onSubmit={handleSubmit}>
        {children}
      </form>
    </PaperplaneFormContext.Provider>
  )
}

export { PaperplaneFormContext, PaperplaneFormProvider }
